// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popper-sources{margin-top:8px;line-height:.4;padding:8px 16px;box-sizing:border-box}.popper-sources:before{content:\" \";position:absolute;display:block;transform:translateY(10px);top:-4px;width:9px;height:9px;right:0;left:0;margin:auto;transform:rotate(45deg);box-shadow:0 2px 20px 0 rgba(0,0,0,.15);background:hsla(0,0%,100%,.95)}", ""]);
// Exports
module.exports = exports;
